import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import enums from 'scoreboard/components/enums'
import i18n from 'scoreboard/components/i18n'
import DbConnectionWizard from 'scoreboard/admin/connections/db-connection-wizard'
import icon from 'scoreboard/components/icon'
import Connection from 'scoreboard/admin/connections/connection'

/**
 * Menu with options for adding a new database import connection
 *
 * @param {Object} options
 * @param {String} options.validationUrl - the url to use for validation
 */
const AddDbConnectionMenu = BootslideMenu.extend({

	initialize: function(options = {}) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.options = options
		this.allowDynamicWidth = true // Optional
	},

	menu: function() {
		let topLevel = []
		this.addTopLevelOptions(topLevel)
		return {
			label: this.menuLabel(),
			target: topLevel
		}
	},

	menuLabel: function() {
		return i18n.get('admin.databaseConnections.action.add.menuLabel')
	},

	addTopLevelOptions: function(topLevel) {
		let dbProducts = ['mysql', 'sqlserver', 'oracle', 'db2', 'hana']
		_.each(dbProducts, product => {
			topLevel.push(this.createDbProductOption(product))
		})
	},

	createDbProductOption: function(product) {
		let label = this.getLabelWithIcon(product)
		return BootslideMenu.targetOption(label, () => {
			let model = new Connection({
				type: 'database',
				standard: true,
				product
			})
			new DbConnectionWizard({
				model,
				validationUrl: this.options.validationUrl
			}).start()
		})
	},

	getLabelWithIcon: function (product) {
		let label = i18n.get(enums.databaseProduct[product])
		let html =
			'<span class="icon-container">' +
			icon('database', 'option-icon') +
			'</span>' +
			`<span class="option-label">${label}</span>`
		return html
	}

})

export default AddDbConnectionMenu
AddDbConnectionMenu.__filename__ = 'admin/connections/add-db-connection-menu.js'
